import { FeatureDTO } from "./FeatureDTO";

export class ReviewFeatureDTO extends FeatureDTO {
    constructor(sub?) {
        super(sub);
    }
}
